import type { Messages } from '../i18n/messages';

/**
 * How a wire block type reads on screen — the `(type)` tag beside a block's title and the
 * options of the add-block select (ADR-031): the catalogue's name for it, or the raw id for a
 * type the catalogue does not list (English lists the raw ids themselves, so `(note)` still
 * renders `(note)`).
 */
export function blockTypeName(messages: Messages, type: string): string {
  return messages.blockType[type] ?? type;
}
